import moment from "moment";

export const isEmpty = (obj: Object) => Object.getOwnPropertyNames(obj).length === 0;

export function formatDateTime(dateString: string):string {
    return moment(dateString).format('YYYY/MM/DD hh:mm A');
}
export function formatDate(dateString: string):string {
    return moment(dateString).format('YYYY/MM/DD');
}